// URL: https://observablehq.com/@jianan-li/visualization-of-my-week
// Title: Visualization of My Week
// Author: Jianan Li (@jianan-li)
// Version: 2504
// Runtime version: 1
/* eslint-disable */
const m0 = {
  id: "f1b554aeba42fe97@2504",
  variables: [
    {
      inputs: ["md"],
      value: (function(md){return(
md`# Visualization of My Week`
)})
    },
    {
      inputs: ["md"],
      value: (function(md){return(
md `### <br/></br>Ok, first some context.`
)})
    },
    {
      inputs: ["html"],
      value: (function(html){return(
html`<br/>
  <img id="grocery-app" src="https://raw.githubusercontent.com/Jianan-Li/Grocery/master/grocery.gif" width="620">
  <style>
    #grocery-app {
      border-radius: 1rem;
    }
  </style>
`
)})
    },
    {
      inputs: ["md"],
      value: (function(md){return(
md `
<br/>
Between 2/7/19 (Thu) and 2/13/19 (Wed), I made a <a href="https://jianan.li" target="_blank">grocery list app</a> both to further my understanding of the iOS development process, and to have something that I can end up using on a weekly basis.
<br/><br/>
In this notebook, I want to show you how I spent my time on this project and how it affected my normal schedule through a visualization.
<br/><br/>In addition to manually recording the time I woke up and went to bed every day, I used the following data collection tools to capture my week in as much detail as possible:
<br/><br/>
<a href="https://timingapp.com/"  target="_blank">Timing</a> (macOS)
<br/>
<a href="https://chrome.google.com/webstore/detail/timeyourweb-time-tracker/kfmlkgchpffnaphmlmjnimonlldbcpnh"  target="_blank">TimeYourWeb Time Tracker</a> (Chrome)
<br/>
<a href="https://chrome.google.com/webstore/detail/webtime-tracker/ppaojnbmmaigjmlpjaldnkgnklhicppk"  target="_blank">Webtime Tracker</a> (Chrome)
<br/><br/>
You can also <a href="https://www.icloud.com/numbers/05nx1DkTJq8Voxu4iKlG8pWOA#Self_Data_Collection"  target="_blank">click here</a> to see the data playground where I wrangled and wrestled with the data before importing them into this notebook.
`
)})
    },
    {
      inputs: ["md"],
      value: (function(md){return(
md `### <br/>Now the visualization ↓`
)})
    },
    {
      inputs: ["html"],
      value: (function(html){return(
html `<br/><br/><br/><br/><br/><br/><br/>`
)})
    },
    {
      name: "chart",
      inputs: ["d3","DOM","width","height","margin","graphWidth","graphHeight","tooltips","eventHandlers","yAxis","myData","timeAwakeAreaGenerator","xAxis","subCategoriesStackedData","colors","stackedAreaGenerator","statistics","tippy","defaultTippyConfig","mainCategoriesStackedData","workingOnTheAppAreaGenerator"],
      value: (function(d3,DOM,width,height,margin,graphWidth,graphHeight,tooltips,eventHandlers,yAxis,myData,timeAwakeAreaGenerator,xAxis,subCategoriesStackedData,colors,stackedAreaGenerator,statistics,tippy,defaultTippyConfig,mainCategoriesStackedData,workingOnTheAppAreaGenerator)
{    
  const svg = d3.select(DOM.svg(width, height));
  
  svg.attr("id", "myGraph");
  
  let asleep = svg.append("rect")
    .attr("x", `${margin.left}`)
    .attr("y", `${margin.top}`)
    .attr("width", `${graphWidth}`)
    .attr("height", `${graphHeight}`)
    .attr("id", "asleep")
    .attr("class", "noSelect")
    .attr("fill", "#002244")
    .attr('data-tippy-content', d => tooltips["Asleep"])
    .on("mouseenter", function(d) {
      d3.selectAll(".subCategory").each(function(d, i) { eventHandlers.restore(this, d) })
      eventHandlers.displayText("33% of the week"); 
    })
    .on("mouseout", function(d) { eventHandlers.displayText("...") })
  
  let yAxisContainer =
  svg.append("g")
    .attr("id", "yAxis")
    .attr("class", "y-axis")
    .attr("transform", `translate(${margin.left},0)`)
    .call(yAxis);
  
  let awake = svg.append("path")
    .datum(myData)
    .attr("id", "awake")
    .attr("class", "area noSelect")
    .attr("fill", "#f9f9f9")
    .attr('data-tippy-content', d => tooltips["Awake"])
    .attr("d", timeAwakeAreaGenerator(false))
    .on("mouseenter", function(d) { 
      d3.selectAll(".subCategory").each(function(d, i) { eventHandlers.restore(this, d) })
      eventHandlers.displayText("56% of awake time"); 
    })
    .on("mouseout", function(d) { eventHandlers.displayText("...") })
  
  // The purpose of this transparentOverlay is to prevent showing tooltip
  // when in the ideal schedule state
  let transparentOverlay = svg.append("rect")
    .attr("x", `${margin.left}`)
    .attr("y", `${margin.top}`)
    .attr("width", `${graphWidth}`)
    .attr("height", `${graphHeight}`)
    .attr("id", "transparentOverlay")
    .attr("fill", "hsla(0,0%,0%,0.0)");
  
  let xAxisContainer = 
  svg.append("g")
    .attr("id", "xAxis")
    .attr("class", "x-axis")
    .attr("transform", `translate(0,${margin.top})`)
    .call(xAxis);
  
  // Google, YouTube, Stack Overflow, ...
  let subCategoriesStack = svg.append("g")
    .selectAll('.area')
    .data(subCategoriesStackedData)
    .enter().append('path')
      .attr('class', 'project categories subCategory area noSelect clickable')
      .attr('fill', d => colors[d.key][0])
      .attr('data-tippy-content', d => tooltips[d.key]) // +"   "+statistics[d.key]
      .attr('d', stackedAreaGenerator(false))
      .on("mouseenter", function(d) { 
        console.log("mouseenter event fired");
        // Assign this to currentElement so that we can use it later for filtering
        let currentElement = this;

        // Fill the other elements with washed out color
        d3.selectAll(".subCategory")
          .filter(function() { return this !== currentElement })
          .each(function(d, i) { eventHandlers.deemphasize(this, d) })

        // Fill the mouse over element with it's original color
        eventHandlers.emphasize(currentElement, d);

        eventHandlers.displayText(statistics[d.key]);

        if (!currentElement._tippy) {
          // console.log(currentElement)
          tippy(this, defaultTippyConfig);
        } else {
          currentElement._tippy.set({
              followCursor: true,
              hideOnClick: false
            })
        }
      })
      .on("mouseout", function (d) {
        let hoverElement = document.querySelectorAll(':hover');
        // hoverElement[2].className === "tippy-popper"
        if (document.getElementsByClassName('tippy-popper').length > 0) {
          // mouse out into a tippy
          // don't change anything
          console.log(`Hover on tippy: ${hoverElement[2].className}`)
          
        }
        else {
          // Fill all elements with original color
          d3.selectAll(".subCategory").each(function(d, i) { eventHandlers.restore(this, d) })
          let hoverElement = document.querySelectorAll(':hover');   
          
          this._tippy.destroy()
        }
      })
      .on("click", function (d) {
        console.log("click event fired");
        let tippyInstance = this._tippy
        if (tippyInstance) {
          if (tippyInstance.props.followCursor === true) {
            tippyInstance.set({
              followCursor: 'initial',
              hideOnClick: true
            })
          } else if (tippyInstance.props.followCursor === 'initial') {
            // tippyInstance.destroy()
            // tippy(this,defaultTippyConfig);
          }
        } else {
          tippy(this,defaultTippyConfig);
        }
      })
  
  // Search, consume, produce information
  let mainCategoriesStack = svg.append("g")
    .selectAll('.area')
    .data(mainCategoriesStackedData)
    .enter().append('path')
      .attr('class', 'project overlay categories mainCategory area noSelect clickable')
      .attr('fill', d => colors[d.key][0])
      .attr('data-tippy-content', d => tooltips[d.key])
      .attr('d', stackedAreaGenerator(false))
      .on("mouseenter", function(d) { 
        // Assign this to currentElement so that we can use it later for filtering
        let currentElement = this;
        
        // Fill the other elements with washed out color
        d3.selectAll(".mainCategory")
          .filter(function() { return this !== currentElement })
          .each(function(d, i) { eventHandlers.deemphasize(this, d) })
        
        // Fill the mouse over element with it's original color
        eventHandlers.emphasize(currentElement, d);
        
        eventHandlers.displayText(statistics[d.key]);    
      })
      .on("mouseout", function (d) { 
        // Fill all elements with original color
        d3.selectAll(".mainCategory").each(function(d, i) { eventHandlers.restore(this, d) })
      })
      .on("click", function(d) { eventHandlers.hideOnClick(this) });
  
  // Working on the app
  let workingOnTheApp = svg.append("path")
    .datum(myData)
    .attr("id", "workingOnTheApp")
    .attr("class", "project overlay area noSelect clickable")
    .attr("fill", d => colors["Working on the App"][0])
    .attr('data-tippy-content', d => tooltips["Working on the App"])
    .attr("d", workingOnTheAppAreaGenerator(false))
    .on("mouseenter", function(d) {
      eventHandlers.highlight(this, "Working on the App");
      eventHandlers.displayText("50h (44% of awake time)");                 
    })
    .on("mouseout", function (d) {
      eventHandlers.dehighlight(this, "Working on the App");
      eventHandlers.displayText("...");
    })
    .on("click", function(d) { eventHandlers.hideOnClick(this) });
  
  let tippyConfig = {
    arrow: false,
    flip: false,
    followCursor: true,
    placement: 'right',
    offset: "60, 10",
    animation: 'fade',
    duration: [100, 100],
    hideOnClick: false
  };
  
  tippy(asleep.node(), tippyConfig);
  tippy(awake.node(), tippyConfig);
  tippy(workingOnTheApp.node(), tippyConfig);
  
  return svg.node();
}
)
    },
    {
      name: "viewof story",
      inputs: ["html"],
      value: (function(html){return(
html`
<div class="flex-container">
  <p id="narrative">...</p>
</div>

<style>
  .flex-container{
    margin: 0;
    display:flex;
    justify-content: center;
    height: 4rem;
  }
  #narrative{
    font-size: 1.5rem;
  }
</style>
`
)})
    },
    {
      name: "story",
      inputs: ["Generators","viewof story"],
      value: (G, _) => G.input(_)
    },
    {
      name: "viewof realityToggleButton",
      inputs: ["html"],
      value: (function(html){return(
html`
<button id="realityToggleButton" name="input" type="button">Show Reality →</button>
`
)})
    },
    {
      name: "realityToggleButton",
      inputs: ["Generators","viewof realityToggleButton"],
      value: (G, _) => G.input(_)
    },
    {
      inputs: ["html"],
      value: (function(html){return(
html `<br/><br/><br/><br/><br/><br/><br/>`
)})
    },
    {
      inputs: ["md"],
      value: (function(md){return(
md`### Some more clickable things`
)})
    },
    {
      name: "viewof graphGridlines",
      inputs: ["radio"],
      value: (function(radio){return(
radio({
  title: 'Show gridlines?',
  description: '',
  options: [
    { label: 'Show', value: "Yes" },
    { label: 'Hide', value: "No" },
  ],
  value: "Yes"
})
)})
    },
    {
      name: "graphGridlines",
      inputs: ["Generators","viewof graphGridlines"],
      value: (G, _) => G.input(_)
    },
    {
      name: "viewof graphStyle",
      inputs: ["radio"],
      value: (function(radio){return(
radio({
  title: 'Style?',
  description: '',
  options: [
    { label: 'Curve', value: 'curveMonotoneX' },
    { label: 'Line', value: 'curveLinear' },
  ],
  value: 'curveMonotoneX'
})
)})
    },
    {
      name: "graphStyle",
      inputs: ["Generators","viewof graphStyle"],
      value: (G, _) => G.input(_)
    },
    {
      name: "viewof unhideOverlaysButton",
      inputs: ["button"],
      value: (function(button){return(
button({value: "Unhide Overlays"})
)})
    },
    {
      name: "unhideOverlaysButton",
      inputs: ["Generators","viewof unhideOverlaysButton"],
      value: (G, _) => G.input(_)
    },
    {
      inputs: ["DOM","serialize","chart"],
      value: (function(DOM,serialize,chart){return(
DOM.download(() => serialize(chart), null, "Save as SVG")
)})
    },
    {
      inputs: ["md"],
      value: (function(md){return(
md `<br/><br/> Here are a few things not included in this visualization:
1. <a href="https://www.notion.so" target="_blank">Notion</a>. While Timing tells me the total time I spent in Notion, there is no data on how much time I spent in Notion for this project vs. other things. To avoid inflating the statistics, I decided to leave it out.
2. Time spend testing the app while away from computer. I did not record this data. iOS Screen Time only tells me the total hours spent in app, which is dominated by the time spent in the app while I was coding.
3. Domains that I visited for a total of less than 60 seconds during the entire week.`
)})
    },
    {
      inputs: ["md"],
      value: (function(md){return(
md `# <br/><br/><br/>Code`
)})
    },
    {
      inputs: ["md"],
      value: (function(md){return(
md `### <br/>Tippy Tooltip Configuration`
)})
    },
    {
      name: "defaultTippyConfig",
      value: (function(){return(
{
    arrow: false,
    flip: true,
    followCursor: true,
    placement: 'right',
    offset: "60, 10",
    animation: 'fade',
    duration: [100, 100],
    hideOnClick: false,
    interactive: true
  }
)})
    },
    {
      inputs: ["md"],
      value: (function(md){return(
md `### Chart Event Handlers`
)})
    },
    {
      name: "eventHandlers",
      inputs: ["d3","colors","$"],
      value: (function(d3,colors,$){return(
{
  hideOnClick: function(clickedElement) {
    d3.select(clickedElement).transition("makeElementTransparent").duration(300).attr("opacity", 0);
    d3.select(clickedElement).transition("hideElement").delay(300).attr("visibility", "hidden");
  },
  highlight: function(element, elementName) {
    d3.select(element).transition("highlight").duration(100).attr("fill", colors[elementName][2]);
  },
  dehighlight: function(element, elementName) {
    d3.select(element).transition("dehighlight").duration(100).attr("fill", colors[elementName][0]);
  },
  emphasize: function(element, data) {
    d3.select(element).transition("emphasize").duration(100).attr("fill", colors[data.key][1]);
  },
  deemphasize: function(element, data) {
    d3.select(element).transition("deemphasize").duration(100).attr("fill", colors[data.key][2]);
  },
  restore: function(element, data) {
    d3.select(element).transition("restore").duration(100).attr("fill", colors[data.key][0]);
  },
  setStrokeOpacity: function(element, val) {
    d3.select(element).attr("stroke-opacity", 1.0);
  },
  displayText: function(text, force) {
    $("#narrative").fadeOut(function() {
      $(this).text(text).fadeIn();
    });
  }
}
)})
    },
    {
      inputs: ["md"],
      value: (function(md){return(
md `### React to Ideal Schedule vs Reality Toggle`
)})
    },
    {
      name: "reality",
      inputs: ["realityToggleButton","eventHandlers","d3","tippy","defaultTippyConfig","timeAwakeAreaGenerator","workingOnTheAppAreaGenerator","stackedAreaGenerator"],
      value: (function(realityToggleButton,eventHandlers,d3,tippy,defaultTippyConfig,timeAwakeAreaGenerator,workingOnTheAppAreaGenerator,stackedAreaGenerator)
{
  // This section updates when the reality toggle button is hit
  realityToggleButton
  
  console.log("haha!!")
  
  // Check the current value of reality
  if (typeof this === 'undefined') {
    // It's undefined at page load, so if it's undefined, initilize as false
    // because we're starting with the planned schedule
    
    // Display the beginning of the story
    eventHandlers.displayText("up at 7:00 and in bed at 10:30 🙂");
    
    return false;
  }
  else {   
    if (this === false) {
      // Switching to reality
      eventHandlers.displayText("lol just kidding 😂 ");
      setTimeout(function(){ eventHandlers.displayText("Hover over graph to explore 🕵️‍♂️"); }, 3000);
      // Make all the overlay areas (that might be hidden) immediately visible
      d3.select("#transparentOverlay")
        .attr("visibility", "hidden");
      d3.select("#workingOnTheApp")
        .attr("opacity", 1)
        .attr("visibility", "visible");
      d3.selectAll(".mainCategory")
        .attr("opacity", 1)
        .attr("visibility", "visible");
      
      // Toggle button name
      d3.select('#realityToggleButton')
        .text("← Show Ideal Schedule");
      
      // Config tippy
      tippy(d3.selectAll(".mainCategory").nodes(),defaultTippyConfig);
      tippy(d3.selectAll(".subCategory").nodes(),defaultTippyConfig);
    }
    else{
      // Switching to plan
      eventHandlers.displayText("up at 7:00 and in bed at 10:30 🙂");
      // Toggle button name
      d3.select('#realityToggleButton')
        .text("   Show Reality →");
      d3.select("#transparentOverlay")
        .attr("visibility", "visible");
    }
    
    d3.select("#awake")
      .transition("expandAwake").duration(1500)
      .attr("d", timeAwakeAreaGenerator(!this));
    d3.select("#workingOnTheApp")
      .transition("expandWorkingOnTheApp").duration(1500)
      .attr("d", workingOnTheAppAreaGenerator(!this));
    d3.selectAll(".categories")
      .transition("expandCategories").duration(1500)
      .attr("d", stackedAreaGenerator(!this));
    
    return !this;
  }
}
)
    },
    {
      inputs: ["md"],
      value: (function(md){return(
md `### React to Unhide Overlays Button Click`
)})
    },
    {
      name: "unhideButtonClicked",
      inputs: ["unhideOverlaysButton","d3"],
      value: (function(unhideOverlaysButton,d3)
{
  // This section updates when the unhide button is hit
  unhideOverlaysButton
  
  // First make overlay areas visible
  d3.selectAll(".overlay")
    .attr("visibility", "visible");
  
  // Then opacity transition from 0 to 1
  d3.selectAll(".overlay")
    .transition("makeElementOpaque")
    .duration(300)
    .attr("opacity", 1.0);
}
)
    },
    {
      inputs: ["md"],
      value: (function(md){return(
md `### Modify and Style Chart (react to chart redraw and option change)`
)})
    },
    {
      name: "modifyChart",
      inputs: ["chart","graphGridlines","d3"],
      value: (function(chart,graphGridlines,d3)
{
  // This is to tell the notebook that this chunk depends on chart
  // so that every time chart update, this block should update too
  chart
  graphGridlines
  
  // These are the things we want to modify
  let dayAxis = d3.select("#xAxis");
  let hourAxis = d3.select("#yAxis")
  
  let dayAxisTicks = dayAxis.selectAll(".tick");
  let hourAxisTicks = hourAxis.selectAll(".tick");
  
  // Hide both axes
  dayAxis.select(".domain")
    .attr("stroke", "hsla(0,0%,0%,0.0)");
  
  hourAxis.select(".domain")
    .attr("stroke", "hsla(0,0%,0%,0.0)");
  
  // Change color of all day axis ticks
  dayAxisTicks
    .selectAll("line")
    .attr("stroke", graphGridlines === "Yes"? "hsla(212, 8%, 52%, 0.5)" : "hsla(212, 8%, 52%, 0)");
  
  // Set the tick mark at 2/13 to be clear
  dayAxisTicks
    .filter(function(){ return ["2/7 Thu","2/13 Wed"].includes(d3.select(this).select("text").text()) })
    .select("line")
    .attr("stroke", "hsla(0,0%,0%,0.0)");
  
  // For all axis labels: set color, font size, and transform to lowercase
  dayAxisTicks
    .selectAll("text")
    .attr("fill","hsl(0, 0%, 40%)")
    .style("font-size","1.2rem")
    // .style("text-transform","lowercase");
  
  hourAxisTicks
    .selectAll("text")
    .attr("fill","hsl(0, 0%, 50%)")
    .style("font-size","1rem")
    .style("text-transform","lowercase");
  
  // Hide the blue selection border for everythin in class .noSelect
  d3.selectAll(".noSelect")
    .style("outline","none");
  
  // Change cursor to pointer for everything in the class .clickable
  d3.selectAll(".clickable")
    .style("cursor","pointer");
}
)
    },
    {
      inputs: ["md"],
      value: (function(md){return(
md`## Data`
)})
    },
    {
      name: "startOfDay",
      value: (function(){return(
new Date('2/7/19 2:40:00 AM')
)})
    },
    {
      name: "endOfDay",
      inputs: ["startOfDay"],
      value: (function(startOfDay){return(
startOfDay.addDays(1).addMinutes(40)
)})
    },
    {
      name: "xAxisTicks",
      value: (function(){return(
[new Date('2/7/19'), new Date('2/8/19'), new Date('2/9/19'), new Date('2/10/19'), new Date('2/11/19'), new Date('2/12/19'), new Date('2/13/19')]
)})
    },
    {
      name: "yAxisTicks",
      inputs: ["startOfDay"],
      value: (function(startOfDay){return(
startOfDay.generateTicks(9, 3, 20)
)})
    },
    {
      name: "myDataCSV",
      value: (function(){return(
`Index,Date,Wake up Time,Go to Sleep Time,Google,YouTube,Stack Overflow,Apple Developer Doc,Other Websites,Write Code,Create Graphics,Make Video,Update Portfolio,Search for Information,Consume Information,Produce Information,Working on the App
0,2/7/19,2/7/19 7:34:00 AM,2/7/19 10:28:00 PM,139,5193,420,848,0,3840,0,0,0,139,6461,3840,10440
1,2/8/19,2/8/19 7:05:00 AM,2/9/19 2:45:00 AM,1074,3360,3720,2182,2354,35280,1809,0,0,1074,11616,37089,49779
2,2/9/19,2/9/19 8:43:00 AM,2/9/19 11:41:00 PM,290,138,1860,1832,325,19320,1119,0,0,290,4155,20439,24884
3,2/10/19,2/10/19 8:04:00 AM,2/11/19 1:15:00 AM,1034,338,4980,648,530,27420,3723,0,0,1034,6496,31143,38673
4,2/11/19,2/11/19 8:08:00 AM,2/12/19 12:21:00 AM,368,109,900,591,342,23820,4879,0,0,368,1942,28699,31009
5,2/12/19,2/12/19 8:06:00 AM,2/12/19 10:53:00 PM,16,0,720,428,0,360,116,0,0,16,1148,476,1640
6,2/13/19,2/13/19 7:08:00 AM,2/13/19 10:34:00 PM,1094,0,300,60,569,2160,4555,4186,11863,1094,929,22764,24787`
)})
    },
    {
      name: "myData",
      inputs: ["d3","myDataCSV"],
      value: (function(d3,myDataCSV){return(
d3.csvParse(myDataCSV, row => ({
  "Index": +row["Index"], 
  "Date": new Date(row["Date"]), 
  "Wake up Time": new Date(row["Wake up Time"]),
  "Go to Sleep Time": new Date(row["Go to Sleep Time"]),
  "Baseline": new Date(row["Baseline"]),
  "Google": +row["Google"], 
  "YouTube": +row["YouTube"], 
  "Stack Overflow": +row["Stack Overflow"], 
  "Apple Developer Doc": +row["Apple Developer Doc"], 
  "Other Websites": +row["Other Websites"], 
  "Write Code": +row["Write Code"], 
  "Create Graphics": +row["Create Graphics"], 
  "Make Video": +row["Make Video"], 
  "Update Portfolio": +row["Update Portfolio"],
  "Search for Information": +row["Search for Information"], 
  "Consume Information": +row["Consume Information"], 
  "Produce Information": +row["Produce Information"],
  "Working on the App": +row["Working on the App"]
}))
)})
    },
    {
      inputs: ["myData"],
      value: (function(myData){return(
myData.columns
)})
    },
    {
      name: "appAreaOffsets",
      value: (function(){return(
[281, 192, 230, 192, 211, 246, 258]
)})
    },
    {
      name: "colors",
      value: (function(){return(
{  
  "Google": ["#DA4251", "#DA4251", "#FFD6DC"],
  "YouTube": ["#ED6F48", "#ED6F48", "#FFE4DB"],
  "Stack Overflow": ["#F7A65B", "#F7A65B", "#FFEEDE"],
  "Apple Developer Doc": ["#FAD785","#FAD785","#FFF8E6"],
  "Other Websites": ["#F6F3A7", "#E8E18B", "#FEFDEE"], 
  "Write Code": ["#D6EA92", "#BDD289", "#F8FCEA"],
  "Create Graphics": ["#A2D69A","#A2D69A","#ECF9EB"],
  "Make Video": ["#64B8A4","#64B8A4","#DFF5F0"],
  "Update Portfolio": ["#4288B5","#4288B5","#D9EFFF"],
  "Search for Information": ["#666666", "#666666", "#bbbbbb"],
  "Consume Information": ["#888888", "#777777", "#cccccc"],
  "Produce Information": ["#aaaaaa", "#888888", "#dddddd"],
  "Working on the App": ["#555555", "#555555", "#888888"]
}
)})
    },
    {
      name: "statistics",
      value: (function(){return(
{
  "Google": "1h (2%)",
  "YouTube": "2.5h (5%)",
  "Stack Overflow": "3.5h (7%)",
  "Apple Developer Doc": "2h (4%)",
  "Other Websites": "1h (2%)",
  "Write Code": "31h (62%)",
  "Create Graphics": "4.5h (9%)",
  "Make Video": "1h (2%)",
  "Update Portfolio": "3.5h (7%)",
  "Search for Information": "1h (2%)",
  "Consume Information": "9h (18%)",
  "Produce Information": "40h (80%)",
}
)})
    },
    {
      name: "tooltips",
      value: (function(){return(
{
  "Google": '<div><a href="https://google.com" target="_blank"><img src="https://github.com/Jianan-Li/icons/raw/master/Google.png" height="50" width="50"/></a></div>Google',
  "YouTube": '<div><a href="https://youtube.com" target="_blank"><img src="https://github.com/Jianan-Li/icons/raw/master/Youtube.png" height="50" width="50"/></a></div>YouTube',
  "Stack Overflow": '<div><a href="https://stackoverflow.com" target="_blank"><img src="https://github.com/Jianan-Li/icons/raw/master/StackOverflow.png" height="50" width="50"/></a></div>Stack Overflow',
  "Apple Developer Doc": '<div><a href="https://developer.apple.com/documentation/" target="_blank"><img src="https://github.com/Jianan-Li/icons/raw/master/Apple.png" height="50" width="50" /></a><a href="https://swift.org/documentation/"  target="_blank"><img src="https://github.com/Jianan-Li/icons/raw/master/Swift.png" height="50" width="50" /></a></div>Apple Developer Doc',
  "Other Websites": '<div><a href="https://medium.com" target="_blank"><img src="https://github.com/Jianan-Li/icons/raw/master/Medium.png" height="50" width="50"/></a><a href="https://www.raywenderlich.com/" target="_blank"><img src="https://github.com/Jianan-Li/icons/raw/master/Raywenderlich.png" height="50" width="50"/></a></div>Other Websites',
  "Write Code": '<div><a href="https://developer.apple.com/xcode/" target="_blank"><img src="https://github.com/Jianan-Li/icons/raw/master/Xcode_1.png" height="50" width="50"/></a></div>Write Code',
  "Create Graphics": '<div><a href="https://figma.com" target="_blank"><img src="https://github.com/Jianan-Li/icons/raw/master/Figma.png" height="50" width="50" /></a><a href="https://geticonjar.com/"  target="_blank"><img src="https://github.com/Jianan-Li/icons/raw/master/Iconjar.png" height="50" width="50" /></a></div><div><a href="https://getpixelsnap.com/"  target="_blank"><img src="https://github.com/Jianan-Li/icons/raw/master/PixelSnap.png" height="50" width="50" /></a><a href="https://sipapp.io/"  target="_blank"><img src="https://github.com/Jianan-Li/icons/raw/master/Sip.png" height="50" width="50" /></a></div>Create Graphics',
  "Make Video": '<div><a href="https://rotato.xyz/" target="_blank"><img src="https://github.com/Jianan-Li/icons/raw/master/Rotato.png" height="50" width="50" /></a><a href="https://www.adobe.com/creativecloud.html"  target="_blank"><img src="https://github.com/Jianan-Li/icons/raw/master/Premiere.png" height="50" width="50" /></a></div>Make Video',
  "Update Portfolio": '<div><a href="https://atom.io/" target="_blank"><img src="https://github.com/Jianan-Li/icons/raw/master/Atom.png" height="50" width="50" /></a><a href="https://hyper.is/"  target="_blank"><img src="https://github.com/Jianan-Li/icons/raw/master/Hyper.png" height="50" width="50" /></a></div><div><a href="https://firebase.google.com/"  target="_blank"><img src="https://github.com/Jianan-Li/icons/raw/master/Firebase.png" height="50" width="50" /></a><a href="https://github.com"  target="_blank"><img src="https://github.com/Jianan-Li/icons/raw/master/Github.png" height="50" width="50" /></a></div>Update Portfolio',
  "Search for Information": '<div class="tippy-emoji">🔍</div>Search for Information',
  "Consume Information": '<div class="tippy-emoji">🍽</div>Consume Information',
  "Produce Information": '<div class="tippy-emoji">✍🏻</div>Produce Information',
  "Working on the App": '<div class="tippy-emoji">👨🏻‍💻</div>Working on app',
  "Awake": '<div class="tippy-emoji">🤹‍♂️</div>Not working on app',
  "Asleep": '<div class="tippy-emoji">😴</div>Sleeping'
}
)})
    },
    {
      inputs: ["md"],
      value: (function(md){return(
md`## Graph Config`
)})
    },
    {
      inputs: ["md"],
      value: (function(md){return(
md`### Dimension`
)})
    },
    {
      inputs: ["width"],
      value: (function(width){return(
width
)})
    },
    {
      name: "height",
      inputs: ["width"],
      value: (function(width){return(
width * 0.55
)})
    },
    {
      name: "margin",
      value: (function(){return(
{
  top: 50,
  bottom: 0,
  left: 80,
  right: 80
}
)})
    },
    {
      name: "graphWidth",
      inputs: ["width","margin"],
      value: (function(width,margin){return(
width - margin.left - margin.right
)})
    },
    {
      name: "graphHeight",
      inputs: ["height","margin"],
      value: (function(height,margin){return(
height - margin.top - margin.bottom
)})
    },
    {
      inputs: ["md"],
      value: (function(md){return(
md`### Scale and Axis`
)})
    },
    {
      name: "x",
      inputs: ["d3","margin","graphWidth"],
      value: (function(d3,margin,graphWidth){return(
d3.scaleTime()
    .domain([new Date('2/7/19'), new Date('2/13/19')])
    .range([margin.left, graphWidth+margin.left])
)})
    },
    {
      name: "y",
      inputs: ["d3","startOfDay","endOfDay","margin","graphHeight"],
      value: (function(d3,startOfDay,endOfDay,margin,graphHeight){return(
d3.scaleLinear()
    .domain([startOfDay, endOfDay])
    .range([margin.top, graphHeight+margin.top])
)})
    },
    {
      name: "xAxis",
      inputs: ["d3","x","graphHeight","xAxisTicks"],
      value: (function(d3,x,graphHeight,xAxisTicks){return(
d3.axisTop(x).tickSize(-graphHeight).tickPadding(20).tickValues(xAxisTicks).tickFormat(d3.timeFormat("%-m/%-d %a"))
)})
    },
    {
      name: "yAxis",
      inputs: ["d3","y","yAxisTicks"],
      value: (function(d3,y,yAxisTicks){return(
d3.axisLeft(y).tickSize(0).tickPadding(10).tickValues(yAxisTicks).tickFormat(d3.timeFormat("%-I %p"))
)})
    },
    {
      inputs: ["md"],
      value: (function(md){return(
md`## Area Chart Generators`
)})
    },
    {
      inputs: ["md"],
      value: (function(md){return(
md `The chart generator produced by <a href="https://github.com/d3/d3-shape/blob/master/README.md#areas" target="_blank">d3.area()</a> is what translate the raw data value into an area on the graph`
)})
    },
    {
      inputs: ["md"],
      value: (function(md){return(
md`1 - Awake`
)})
    },
    {
      name: "timeAwakeAreaGenerator",
      inputs: ["d3","graphStyle","x","y"],
      value: (function(d3,graphStyle,x,y){return(
function(reality) {
  return d3.area()
    .curve(graphStyle == 'curveMonotoneX'? d3.curveMonotoneX : d3.curveLinear)
    .x(d => x(d.Date))
    .y0(d => reality ? y(d["Wake up Time"].subtractDays(d.Index)) : y(new Date("2/7/19 7:00:00 AM")) )
    .y1(d => reality ? y(d["Go to Sleep Time"].subtractDays(d.Index)) : y(new Date("2/7/19 10:30:00 PM")));
}
)})
    },
    {
      inputs: ["md"],
      value: (function(md){return(
md`2 - Working on the app`
)})
    },
    {
      name: "workingOnTheAppAreaGenerator",
      inputs: ["d3","graphStyle","x","y","appAreaOffsets"],
      value: (function(d3,graphStyle,x,y,appAreaOffsets){return(
function(reality) {
  return d3.area()
    .curve(graphStyle == 'curveMonotoneX'? d3.curveMonotoneX : d3.curveLinear)
    .x(d => x(d.Date))
    .y0(d => reality ?
        y(d["Wake up Time"]
          .subtractDays(d.Index).addMinutes(appAreaOffsets[d.Index]))
        : y(new Date("2/7/19 12:00:00 PM")))
    .y1(d => reality ?
        y(d["Wake up Time"]
          .subtractDays(d.Index).addMinutes(appAreaOffsets[d.Index]).addSeconds(d["Working on the App"])) 
        : y(new Date("2/7/19 12:00:00 PM")));
}
)})
    },
    {
      inputs: ["md"],
      value: (function(md){return(
md`3 - Stacked Categories`
)})
    },
    {
      name: "stackedAreaGenerator",
      inputs: ["d3","graphStyle","x","y","appAreaOffsets"],
      value: (function(d3,graphStyle,x,y,appAreaOffsets){return(
function(reality) {
  return d3.area()
    .curve(graphStyle == 'curveMonotoneX'? d3.curveMonotoneX : d3.curveLinear)
    .x(d => x(d.data.Date))
    .y0(d => reality ?
        y(d.data["Wake up Time"]
          .subtractDays(d.data.Index).addMinutes(appAreaOffsets[d.data.Index]).addSeconds(d[0]))
      : y(new Date("2/7/19 12:00:00 PM")))
    .y1(d => reality ?
        y(d.data["Wake up Time"]
          .subtractDays(d.data.Index).addMinutes(appAreaOffsets[d.data.Index]).addSeconds(d[1]))
      : y(new Date("2/7/19 12:00:00 PM")));
}
)})
    },
    {
      inputs: ["md"],
      value: (function(md){return(
md `3.1 - Main Categories`
)})
    },
    {
      name: "mainCategoriesStackedData",
      inputs: ["myData","d3"],
      value: (function(myData,d3)
{
  const keys = myData.columns.slice(-4, -1);
  const stack = d3.stack()
  	.keys(keys)
  	.order(d3.stackOrderAescending);
  return stack(myData);
}
)
    },
    {
      inputs: ["md"],
      value: (function(md){return(
md `3.2 - Sub Categories`
)})
    },
    {
      name: "subCategoriesStackedData",
      inputs: ["myData","d3"],
      value: (function(myData,d3)
{
  const keys = myData.columns.slice(4, -4);
  const stack = d3.stack()
  	.keys(keys)
  	.order(d3.stackOrderAescending);
  return stack(myData);
}
)
    },
    {
      inputs: ["md"],
      value: (function(md){return(
md`## Helper Functions`
)})
    },
    {
      value: (function(){return(
Date.prototype.generateTicks = function(numberOfTicks, gapInHours, offsetMinutes) {
    let startTick = new Date(this.valueOf());
    startTick = startTick.addMinutes(offsetMinutes)
    let ticks = []
    for (let i = 0; i < numberOfTicks; i++) {
      let nextTick = startTick.addHours(i*gapInHours)
      ticks.push(nextTick)
    }
    return ticks;
}
)})
    },
    {
      value: (function(){return(
Date.prototype.subtractDays = function(days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() - days);
    return date;
}
)})
    },
    {
      value: (function(){return(
Date.prototype.addDays = function(days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
}
)})
    },
    {
      value: (function(){return(
Date.prototype.addHours = function(hours) {
    var date = new Date(this.valueOf());
    date.setHours(date.getHours() + hours);
    return date;
}
)})
    },
    {
      value: (function(){return(
Date.prototype.addMinutes= function(minutes) {
    var date = new Date(this.valueOf());
    date.setMinutes(date.getMinutes() + minutes);
    return date;
}
)})
    },
    {
      value: (function(){return(
Date.prototype.addSeconds= function(seconds) {
    var date = new Date(this.valueOf());
    date.setSeconds(date.getSeconds() + seconds);
    return date;
}
)})
    },
    {
      inputs: ["md"],
      value: (function(md){return(
md`## Page Styling`
)})
    },
    {
      inputs: ["md"],
      value: (function(md){return(
md`Set notebook font to Apple system font (i.e. San Francisco)`
)})
    },
    {
      inputs: ["$"],
      value: (function($){return(
$( "*" ).css( "font-family", "-apple-system,system-ui,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,sans-serif" )
)})
    },
    {
      inputs: ["md"],
      value: (function(md){return(
md `Center the reality toggle button by wrapping it in a flex container`
)})
    },
    {
      inputs: ["$"],
      value: (function($){return(
$("#realityToggleButton").wrap('<div class="flex-container"></div>')
)})
    },
    {
      inputs: ["md"],
      value: (function(md){return(
md `CSS Styling`
)})
    },
    {
      inputs: ["html"],
      value: (function(html){return(
html `
  <style>
    #realityToggleButton {
      transition: background-color 0.2s;
      font-size: 1rem;
      width: 12rem;
      height: 2.2rem;
      text-decoration: none;
      border-radius: 0.5rem;
      outline: none;
      cursor: pointer;
      border: none;
      background-color: #eee;
      margin-top: 1rem;
    }
    #realityToggleButton:hover {
      background-color: #ddd;
    }
     #realityToggleButton:active {
      background-color: #ccc;
    }
    .tooltipImage {
      width = 6rem;
      height = 6rem;
    }
    .tippy-tooltip {
      font-size: 1.1rem;
      padding: 0.3rem 0.6rem;
    }
    .tippy-emoji {
      font-size: 3rem;
    }
  </style>
`
)})
    },
    {
      inputs: ["md"],
      value: (function(md){return(
md`## Import D3 and other libraries`
)})
    },
    {
      from: "@mbostock/saving-svg",
      name: "serialize",
      remote: "serialize"
    },
    {
      from: "@jashkenas/inputs",
      name: "slider",
      remote: "slider"
    },
    {
      from: "@jashkenas/inputs",
      name: "radio",
      remote: "radio"
    },
    {
      from: "@jashkenas/inputs",
      name: "button",
      remote: "button"
    },
    {
      name: "$",
      inputs: ["require"],
      value: (function(require){return(
require("https://cdnjs.cloudflare.com/ajax/libs/jquery/3.3.1/jquery.min.js")
)})
    },
    {
      name: "tippy",
      inputs: ["require"],
      value: (function(require){return(
require("https://unpkg.com/tippy.js@4.0.0")
)})
    },
    {
      name: "popper",
      inputs: ["require"],
      value: (function(require){return(
require("https://unpkg.com/popper.js@1/dist/umd/popper.min.js")
)})
    },
    {
      name: "d3",
      inputs: ["require"],
      value: (function(require){return(
require("d3@5")
)})
    }
  ]
};

const m1 = {
  id: "@mbostock/saving-svg",
  variables: [
    {
      name: "serialize",
      inputs: ["NodeFilter"],
      value: (function(NodeFilter)
{
  const xmlns = "http://www.w3.org/2000/xmlns/";
  const xlinkns = "http://www.w3.org/1999/xlink";
  const svgns = "http://www.w3.org/2000/svg";
  return function serialize(svg) {
    svg = svg.cloneNode(true);
    const fragment = window.location.href + "#";
    const walker = document.createTreeWalker(svg, NodeFilter.SHOW_ELEMENT, null, false);
    while (walker.nextNode()) {
      for (const attr of walker.currentNode.attributes) {
        if (attr.value.includes(fragment)) {
          attr.value = attr.value.replace(fragment, "#");
        }
      }
    }
    svg.setAttributeNS(xmlns, "xmlns", svgns);
    svg.setAttributeNS(xmlns, "xmlns:xlink", xlinkns);
    const serializer = new window.XMLSerializer;
    const string = serializer.serializeToString(svg);
    return new Blob([string], {type: "image/svg+xml"});
  };
}
)
    }
  ]
};

const m2 = {
  id: "@jashkenas/inputs",
  variables: [
    {
      name: "slider",
      inputs: ["input"],
      value: (function(input){return(
function slider(config = {}) {
  let {value, min = 0, max = 1, step = "any", precision = 2, title, description, getValue, format, display, submit} = config;
  if (typeof config == "number") value = config;
  if (value == null) value = (max + min) / 2;
  precision = Math.pow(10, precision);
  if (!getValue) getValue = input => Math.round(input.valueAsNumber * precision) / precision;
  return input({
    type: "range", title, description, submit, format, display,
    attributes: {min, max, step, value},
    getValue
  });
}
)})
    },
    {
      name: "radio",
      inputs: ["input","html"],
      value: (function(input,html){return(
function radio(config = {}) {
  let { value: formValue, title, description, submit, options } = config;
  if (Array.isArray(config)) options = config;
  options = options.map(
    o => (typeof o === "string" ? { value: o, label: o } : o)
  );
  const form = input({
    type: "radio",
    title,
    description,
    submit,
    getValue: input => {
      const checked = Array.prototype.find.call(input, radio => radio.checked);
      return checked ? checked.value : undefined;
    },
    form: html`
      <form>
        ${options.map(({ value, label }) => {
          const input = html`<input type=radio name=input ${
            value === formValue ? "checked" : ""
          } style="vertical-align: baseline;" />`;
          input.setAttribute("value", value);
          const tag = html`
          <label style="display: inline-block; margin: 5px 10px 3px 0; font-size: 0.85em;">
           ${input}
           ${label}
          </label>`;
          return tag;
        })}
      </form>
    `
  });
  form.output.remove();
  return form;
}
)})
    },
    {
      name: "button",
      inputs: ["input"],
      value: (function(input){return(
function button(config = {}) {
  let {value, title, description, disabled} = config;
  if (typeof config == "string") value = config;
  if (!value) value = "Ok";
  const form = input({
    type: "button", title, description,
    attributes: {disabled, value}
  });
  form.output.remove();
  return form;
}
)})
    },
    {
      name: "input",
      inputs: ["html","d3format"],
      value: (function(html,d3format){return(
function input(config) {
  let {
    form,
    type = "text",
    attributes = {},
    action,
    getValue,
    title,
    description,
    format,
    display,
    submit,
    options
  } = config;
  const wrapper = html`<div></div>`;
  if (!form)
    form = html`<form>
	<input name=input type=${type} />
  </form>`;
  Object.keys(attributes).forEach(key => {
    const val = attributes[key];
    if (val != null) form.input.setAttribute(key, val);
  });
  if (submit)
    form.append(
      html`<input name=submit type=submit style="margin: 0 0.75em" value="${
        typeof submit == "string" ? submit : "Submit"
      }" />`
    );
  form.append(
    html`<output name=output style="font: 14px Menlo, Consolas, monospace; margin-left: 0.5em;"></output>`
  );
  if (title)
    form.prepend(
      html`<div style="font: 700 0.9rem sans-serif;">${title}</div>`
    );
  if (description)
    form.append(
      html`<div style="font-size: 0.85rem; font-style: italic;">${description}</div>`
    );
  if (format) format = typeof format === "function" ? format : d3format.format(format);
  if (action) {
    action(form);
  } else {
    const verb = submit
      ? "onsubmit"
      : type == "button"
      ? "onclick"
      : type == "checkbox" || type == "radio"
      ? "onchange"
      : "oninput";
    form[verb] = e => {
      e && e.preventDefault();
      const value = getValue ? getValue(form.input) : form.input.value;
      if (form.output) {
        const out = display ? display(value) : format ? format(value) : value;
        if (out instanceof window.Element) {
          while (form.output.hasChildNodes()) {
            form.output.removeChild(form.output.lastChild);
          }
          form.output.append(out);
        } else {
          form.output.value = out;
        }
      }
      form.value = value;
      if (verb !== "oninput")
        form.dispatchEvent(new CustomEvent("input", { bubbles: true }));
    };
    if (verb !== "oninput")
      wrapper.oninput = e => e && e.stopPropagation() && e.preventDefault();
    if (verb !== "onsubmit") form.onsubmit = e => e && e.preventDefault();
    form[verb]();
  }
  while (form.childNodes.length) {
    wrapper.appendChild(form.childNodes[0]);
  }
  form.append(wrapper);
  return form;
}
)})
    },
    {
      name: "d3format",
      inputs: ["require"],
      value: (function(require){return(
require("d3-format@1")
)})
    }
  ]
};

const notebook = {
  id: "f1b554aeba42fe97@2504",
  modules: [m0,m1,m2]
};

export default notebook;
